var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* global WebSocket */
/**
 * Created by maxime on 2016-03-28.
 */
import { LogFactory } from '../modules/config/logging';
import ChannelEvents from './channelEvents';
import ConfigsManager from '../modules/config/configs';
import { Timer, Interval } from '../JiveSessionUtils';
import { isGatewayCorrelatedResponse } from './channel.models';
var Logger = LogFactory('Channel');
/**
 * Class representing a WebSocket connection.
 * The constructor is called internally within JiveRTC when a Session constructor is initialized.
 */
var Channel = /** @class */ (function (_super) {
    __extends(Channel, _super);
    function Channel(_authentication) {
        var _this = _super.call(this) || this;
        _this._authentication = _authentication;
        /**
         * Create a WebSocket Channel.
         * @param {string} authentication - The credentials of the user to use for register refresh or fail recovery.
         */
        _this._ws = null;
        _this._url = null;
        _this._existingSession = false;
        _this._reconnectTimeout = null;
        _this._disconnectTimeout = null;
        _this._pingInterval = null;
        _this._state = _this.DISCONNECTED;
        _this._correlationId = 0;
        _this._attempts = 0;
        _this._requests = new Map();
        _this._online = navigator.onLine;
        _this._terminated = false;
        _this._unauthorized = false;
        _this._PING_COMMAND = 'ping';
        window.addEventListener('online', function (event) { return _this._onlineStatus(event); });
        window.addEventListener('offline', function (event) { return _this._onlineStatus(event); });
        return _this;
    }
    Channel.prototype.connect = function () {
        var _this = this;
        // User is logged out
        if (this._terminated || this._unauthorized) {
            return;
        }
        if (!this._online) {
            Logger.log("Connection offline, next reconnecting attempt in " + ConfigsManager.DISCONNECTED_TIMEOUT + "ms");
            if (this._reconnectTimeout) {
                this._reconnectTimeout.stop();
            }
            this._reconnectTimeout = new Timer(function () { return _this.connect(); }, ConfigsManager.DISCONNECTED_TIMEOUT);
            return;
        }
        this._url = this._url !== null ? this._url : ConfigsManager.socketUrl;
        Logger.log('Opening connection', this._url);
        var disconnect = function () {
            if (!_this._online) {
                _this.setState(_this.DISCONNECTED, _this.NETWORK_OFFLINE);
                return;
            }
            _this.setState(_this.DISCONNECTED, _this.NETWORK_NOT_RESPONDING);
        };
        if (this._disconnectTimeout) {
            this._disconnectTimeout.stop();
        }
        this._disconnectTimeout = new Timer(disconnect, ConfigsManager.REQUEST_TIMEOUT);
        this._ws = null;
        this._ws = new WebSocket(this._url);
        this._ws.onopen = function (e) { return _this._onOpenHandler(); };
        this._ws.onclose = function (e) { return _this._onCloseHandler(e); };
        this._ws.onerror = function (e) { return _this._onErrorHandler(e); };
        this._ws.onmessage = function (e) { return _this._onMessageHandler(e); };
    };
    Channel.prototype.send = function (command, data) {
        var _this = this;
        this._correlationId++;
        var request = {
            correlationId: this._correlationId,
            command: command,
            data: data
        };
        return new Promise(function (resolve, reject) {
            // Network offline scenario
            if (!_this._online && command !== _this._PING_COMMAND) {
                Logger.warn('Internet connection offline, not sending request', request);
                return reject(_this.NETWORK_OFFLINE);
            }
            // Websocket not established scenario
            if (!_this._ws) {
                Logger.warn('Connection not established, not sending request', request);
                _this.connect();
                return reject(_this.WEBSOCKET_NOT_CONNECTED);
            }
            if (command !== _this._PING_COMMAND) {
                if (_this._ws.readyState !== 1) {
                    Logger.warn('Channel: Not in ready state, not sending request', request);
                    return reject(_this.WEBSOCKET_NOT_READY);
                }
                Logger.log('Sending request', request);
            }
            var requestTimer;
            var timeout = function () {
                _this._requests.delete(request.correlationId);
                return reject(_this.REQUEST_TIMEOUT);
            };
            if (command !== _this._PING_COMMAND) {
                requestTimer = new Timer(timeout, ConfigsManager.REQUEST_TIMEOUT);
            }
            else {
                requestTimer = new Timer(timeout, ConfigsManager.PING_TIMEOUT);
            }
            var promise = {
                resolve: resolve,
                reject: reject,
                command: command,
                requestTimer: requestTimer
            };
            _this._requests.set(_this._correlationId, promise);
            _this._ws.send(JSON.stringify(request));
        });
    };
    Channel.prototype.close = function () {
        this._terminated = true;
        if (this._ws) {
            this._ws.close();
        }
    };
    Channel.prototype._onOpenHandler = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1, retryAfter;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.log('Connection established');
                        this._attempts = 0;
                        if (this._reconnectTimeout) {
                            this._reconnectTimeout.stop();
                        }
                        if (this._disconnectTimeout) {
                            this._disconnectTimeout.stop();
                        }
                        if (this._pingInterval) {
                            this._pingInterval.stop();
                        }
                        if (this._url && this._url !== ConfigsManager.socketUrl) {
                            this._existingSession = true;
                            this.setState(this.CONNECTED);
                            this._requests.forEach(function (promise) { return promise.requestTimer.resume(); });
                            this._pingInterval = new Interval(function () { return _this._ping(); }, ConfigsManager.PING_INTERVAL);
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.send('authenticate', this._authentication)];
                    case 2:
                        response = _a.sent();
                        Logger.log('Authentication success');
                        this.setState(this.CONNECTED);
                        this._requests.forEach(function (promise) { return promise.requestTimer.resume(); });
                        this._url = response.ws;
                        this._existingSession = true;
                        this._pingInterval = new Interval(function () { return _this._ping(); }, ConfigsManager.PING_INTERVAL);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        Logger.error('Authentication failure:', error_1);
                        this._url = null;
                        this._existingSession = false;
                        this._requests.forEach(function (promise) { return promise.reject(error_1); });
                        this._requests.clear();
                        if (error_1.errorCode === this.UNAVAILABLE.errorCode) {
                            if (error_1.constraintViolations && error_1.constraintViolations.length > 0) {
                                if (error_1.constraintViolations[0].constraint) {
                                    retryAfter = Number.parseInt(error_1.constraintViolations[0].constraint, 10);
                                    this._reconnectTimeout = new Timer(function () { return _this._onOpenHandler(); }, retryAfter * 1000);
                                }
                            }
                        }
                        if (error_1.errorCode === this.UNAUTHORIZED.errorCode) {
                            this._unauthorized = true;
                            if (this._disconnectTimeout) {
                                this._disconnectTimeout.stop();
                            }
                            if (this._reconnectTimeout) {
                                this._reconnectTimeout.stop();
                            }
                            if (this._ws) {
                                this._ws.close();
                            }
                        }
                        delete error_1.constraintViolations;
                        this.setState(this.DISCONNECTED, error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype._onErrorHandler = function (wsEvent) {
        Logger.error('Error event', wsEvent);
        this.emit(this.ERROR, this.WEBSOCKET_ERROR);
    };
    Channel.prototype._onCloseHandler = function (wsEvent) {
        var _this = this;
        Logger.warn('Close event', wsEvent);
        if (this._ws && this._ws.readyState === 1) {
            return;
        }
        this._attempts++;
        if (this._attempts > 1) {
            this._url = null;
            this._existingSession = false;
            this._requests.forEach(function (promise) { return promise.reject(_this.SESSION_LOST); });
            this._requests.clear();
        }
        if (this._attempts >= 2) {
            this.setState(this.DISCONNECTED, this.WEBSOCKET_CLOSE);
        }
        if (this._reconnectTimeout) {
            this._reconnectTimeout.stop();
        }
        if (this._pingInterval) {
            this._pingInterval.stop();
        }
        var delay = (this._attempts > 4 ? 15 : Math.pow(2, this._attempts)) * 1000;
        if (this._online) {
            this._reconnectTimeout = new Timer(function () { return _this.connect(); }, delay);
        }
    };
    Channel.prototype._onMessageHandler = function (wsEvent) {
        var message = JSON.parse(wsEvent.data);
        if (isGatewayCorrelatedResponse(message) && this._requests.has(message.correlationId)) {
            var promise = this._requests.get(message.correlationId);
            if (promise) {
                if (message.code >= 200 && message.code < 300) {
                    if (promise.command !== this._PING_COMMAND) {
                        Logger.log('Receiving correlated message', message);
                    }
                    promise.resolve(message.data);
                }
                else {
                    var error = message.error;
                    Logger.warn('Receiving error', error);
                    promise.reject(error);
                }
            }
            this._requests.delete(message.correlationId);
            return;
        }
        Logger.log('Receiving uncorrelated message', message);
        this.emit(this.MESSAGE, message);
    };
    Channel.prototype._onlineStatus = function (event) {
        var _this = this;
        Logger.log('Network condition', event.type);
        if (event.type !== 'online') {
            this._online = false;
            if (this._pingInterval) {
                this._pingInterval.stop();
            }
            this._requests.forEach(function (promise) { return promise.requestTimer.pause(); });
            this.setState(this.DISCONNECTED, this.NETWORK_OFFLINE);
            return;
        }
        this._online = true;
        if (!this._ws) {
            this.connect();
        }
        if (this._pingInterval) {
            this._pingInterval.stop();
        }
        this._ping();
        this._pingInterval = new Interval(function () { return _this._ping(); }, ConfigsManager.PING_INTERVAL);
    };
    Channel.prototype._ping = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._online) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.send(this._PING_COMMAND)];
                    case 2:
                        _a.sent();
                        this.setState(this.CONNECTED);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        Logger.error('Error:', error_2);
                        if (this.state !== this.DISCONNECTED) {
                            this.setState(this.DISCONNECTED, error_2);
                        }
                        if (this._pingInterval) {
                            this._pingInterval.stop();
                        }
                        this._requests.forEach(function (promise) { return promise.reject(_this.REQUEST_TIMEOUT); });
                        this._requests.clear();
                        this.connect();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.setState = function (state, error) {
        if (state === this.CONNECTED) {
            if (this.state !== this.CONNECTED) {
                this._state = state;
                this.emit(this.CONNECTED, this._existingSession);
            }
        }
        else {
            this._state = state;
            this.emit(this.DISCONNECTED, error);
        }
    };
    Object.defineProperty(Channel.prototype, "state", {
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Channel.prototype, "hasOngoingSession", {
        get: function () {
            return this._existingSession;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Channel.prototype, "authentication", {
        set: function (authentication) {
            this._authentication = authentication;
            // If channel stopped by bad authentication, retry
            if (this._unauthorized) {
                this._unauthorized = false;
                this.connect();
            }
        },
        enumerable: true,
        configurable: true
    });
    return Channel;
}(ChannelEvents));
export default Channel;
//# sourceMappingURL=channel.js.map